import React, { useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import FormSettingFields from "./FormSettingFields";
import FormFields from "./FormFields";
import { Box, Button } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import FormRequests from "services/FormBuilder";
import {
  setEditingField,
  setFormFields,
  setFormSettings,
} from "redux/actions/FormBuilder";
import {
  convertToStandardFormat,
  dateFormat,
} from "@jumbo/utils/shamsiStandardFormat";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { DateObject } from "react-multi-date-picker";
import { fetchError } from "redux/actions";
import { set } from "lodash";

const CurrFormContainer = ({ isSetting }) => {
  const { formSettings, formFields, form } = useSelector(
    ({ formBuilder }) => formBuilder
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setEditingField(""));
  }, [dispatch]);

  const submitForm = () => {
    const data = {
      title: formSettings.formTitle,
      subtitle: formSettings.formSubTitle,
      icon: formSettings.formIcon,
      poster: formSettings.formPoster,
      description: formSettings.formDesc,
      type: formSettings.formType,
      confirmation: formSettings.confirmation,
      privacyMode: Boolean(formSettings.privacyMode),
      active: formSettings.active,
      archived: formSettings.archived,
      confirmationMessage: {
        customSMSMessageEnabled: formSettings?.customSMSMessageEnabled || false,
        customSMSMessage: formSettings?.customSMSMessage || "",
        customFormMessageEnabled:
          formSettings?.customFormMessageEnabled || false,
        customFormMessage: formSettings?.customFormMessage || "",
      },
    };
    const limits = {
      date: formSettings.hasDateLimit,
      count: formSettings.formLimit,
      accessList: formSettings.accessList,
      blackList: formSettings.blackAccessList,
      family: formSettings.family,
      removable: formSettings.removable,
    };
    if (
      !formSettings.formTitle ||
      !formSettings.formType ||
      !formSettings.confirmation
    ) {
      dispatch(fetchError("موارد مورد نیاز را وارد نمایید"));
      return;
    }
    if (
      formSettings.formType === "Exam" &&
      (!formSettings.maxQuestions || +formSettings.maxQuestions < 1)
    ) {
      dispatch(fetchError("تعداد سوال‌های آزمون باید حداقل ۱ باشد"));
      return;
    }
    if (
      formSettings.formType === "Exam" &&
      formSettings.durationEnabled &&
      (!formSettings.durationMinutes || +formSettings.durationMinutes < 1)
    ) {
      dispatch(fetchError("مدت زمان پاسخگویی باید حداقل ۱ دقیقه باشد"));
      return;
    }
    if (formSettings.formLimit) {
      limits["countLimit"] = +formSettings.limitCount;
    }
    if (formSettings.hasDateLimit) {
      limits["startDate"] = convertToStandardFormat(
        formSettings.startDate
          ? formSettings.startDate.gregorian
          : dateFormat.gregorian
      );
      limits["endDate"] = convertToStandardFormat(
        formSettings.endDate
          ? formSettings.endDate.gregorian
          : dateFormat.gregorian
      );
    }
    if (formSettings.accessList) {
      limits["accessListTopic"] = limits["accessListTopic"] =
        formSettings.accessListTopic;
      limits["accessListType"] = limits["accessListType"] =
        formSettings.accessListType;
    }
    if (formSettings.blackAccessList) {
      limits["blackListTopic"] = limits["blackAccessListTopic"] =
        formSettings.blackAccessListTopic;
      limits["blackListType"] = limits["blackAccessListType"] =
        formSettings.blackAccessListType;
      limits["blackListError"] = limits["blackAccessListError"] =
        formSettings.blackAccessListError;
    }
    data["limits"] = limits;
    if (formSettings.formType === "Exam") {
      data["examSettings"] = {
        maxQuestions: +formSettings.maxQuestions,
        durationEnabled: Boolean(formSettings.durationEnabled),
        durationMinutes: formSettings.durationEnabled
          ? +formSettings.durationMinutes
          : 1,
      };
    }
    if (formFields.length !== 0) {
      const formattedData = formFields.map((item) => {
        const data = {
          title: item.title === "عنوان فیلد" ? "" : item.title,
          subtitle: item.subtitle === "زیرعنوان فیلد" ? "" : item.subtitle,
          description: item.desc === "توضیحات فیلد" ? "" : item.desc,
        };
        let detailsData;
        if (item.type === "Text") {
          detailsData = {
            type: item.type,
          };
        } else {
          detailsData = {
            type: item.type,
            required: item.required,
            visibilityCondition: item.visibilityCondition,
            examQuestion: item.examQuestion,
          };
        }
        if (item.visibilityCondition) {
          detailsData["visibilityConditionSource"] =
            item.visibilityConditionSource;
          detailsData["visibilityConditionValue"] =
            item.visibilityConditionValue;
        }
        if (
          item.type === "Textfield" ||
          item.type === "TextArea" ||
          item.type === "Number" ||
          item.type === "Phone"
        ) {
          detailsData["placeholderText"] =
            item.placeHolder === "متن جایگزین فیلد" ? "" : item.placeHolder;
        } else if (item.type === "CheckBox" || item.type === "RadioButton") {
          const selectionListData = item.selectionList.map(
            ({ id, ...rest }) => {
              if (rest.limits) {
                const { gregorian: endDateGregorian } =
                  rest.limits.endDate || {};
                const { gregorian: startDateGregorian } =
                  rest.limits.startDate || {};
                return {
                  ...rest,
                  markAsAttended: rest.markAsAttended || false,
                  limits: {
                    ...rest.limits,
                    startDate: startDateGregorian,
                    endDate: endDateGregorian,
                  },
                };
              }
              return rest;
            }
          );
          detailsData["selectionList"] = selectionListData;
          if (item.type === "RadioButton") {
            detailsData["examQuestionHasRightAnswer"] =
              item.examQuestionHasRightAnswer;
            if (item.examQuestionHasRightAnswer) {
              detailsData["examQuestionRightAnswer"] =
                item.examQuestionRightAnswer;
            }
          }
        } else if (item.type === "File") {
          detailsData["fileType"] = item.fileType || "all";
        }
        data["details"] = detailsData;
        if (item._id) {
          data["_id"] = item._id;
        }
        return data;
      });
      data["fields"] = formattedData;
    }
    if (form) {
      dispatch(FormRequests.updateForm(data, form._id));
    } else {
      dispatch(FormRequests.createForm(data));
    }
  };

  useEffect(() => {
    if (form) {
      const settings = {
        formId: form._id,
        formTitle: form.title,
        formDesc: form.description,
        formType: form.type,
        formPoster: form?.poster,
        confirmation: form?.confirmation,
        privacyMode: Boolean(form?.privacyMode),
        formSubTitle: form?.subtitle,
        formIcon: form?.icon,
        active: form?.active,
        archived: form?.archived,
        formLimit: form.limits.count,
        hasDateLimit: form.limits.date,
        accessList: form.limits.accessList,
        blackAccessList: form.limits.blackList,
        family: form.limits.family,
        removable: form.limits.removable,
        customSMSMessageEnabled:
          form?.confirmationMessage?.customSMSMessageEnabled || false,
        customSMSMessage: form?.confirmationMessage?.customSMSMessage || "",
        customFormMessageEnabled:
          form?.confirmationMessage?.customFormMessageEnabled || false,
        customFormMessage: form?.confirmationMessage?.customFormMessage || "",
        maxQuestions: form?.examSettings?.maxQuestions || 0,
        durationEnabled: form?.examSettings?.durationEnabled || false,
        durationMinutes: form?.examSettings?.durationMinutes || 1,
      };
      if (form.limits.count) {
        settings["limitCount"] = form.limits.countLimit;
      }
      if (form.limits.accessList) {
        settings["accessListTopic"] = form.limits.accessListTopic;
        settings["accessListType"] = form.limits.accessListType;
      }
      if (form.limits.blackList) {
        settings["blackAccessListTopic"] = form.limits.blackListTopic;
        settings["blackAccessListType"] = form.limits.blackListType;
        settings["blackAccessListError"] = form.limits.blackListError;
      }
      if (form.limits.date) {
        settings["startDate"] = {
          date: form.limits.startDate,
          gregorian: new DateObject({
            date: form.limits.startDate,
            format: "HH:mm:ss   YYYY/MM/DD",
          })
            .convert(gregorian, gregorian_en)
            .format(),
        };
        settings["endDate"] = {
          date: form.limits.endDate,
          gregorian: new DateObject({
            date: form.limits.endDate,
            format: "HH:mm:ss   YYYY/MM/DD",
          })
            .convert(gregorian, gregorian_en)
            .format(),
        };
      }
      dispatch(setFormSettings(settings));
      const fields = form.fields.map((item) => {
        let field;
        if (item.details.type === "Text") {
          field = {
            _id: item._id,
            title: item.title,
            subtitle: item.subtitle,
            desc: item.description,
            type: item.details.type,
          };
        } else {
          field = {
            _id: item._id,
            title: item.title,
            subtitle: item.subtitle,
            desc: item.description,
            type: item.details.type,
            required: item.details.required,
            visibilityCondition: item.details.visibilityCondition,
            examQuestion: item.details?.examQuestion || false,
          };
        }

        if (
          item.details.type === "Textfield" ||
          item.details.type === "TextArea" ||
          item.details.type === "Phone" ||
          item.details.type === "Number"
        ) {
          field["placeHolder"] = item.details.placeholderText;
        } else if (
          item.details.type === "CheckBox" ||
          item.details.type === "RadioButton"
        ) {
          const transformedSelectionList = item.details.selectionList.map(
            (form) => {
              const startDate = form.limits?.startDate;
              const endDate = form.limits?.endDate;
              // const { startDate, endDate } = form.limits;

              const formattedStartDate = startDate
                ? {
                    date: startDate,
                    gregorian: new DateObject({
                      date: startDate,
                      format: "HH:mm:ss   YYYY/MM/DD",
                    })
                      .convert(gregorian, gregorian_en)
                      .format(),
                  }
                : dateFormat;

              const formattedEndDate = endDate
                ? {
                    date: endDate,
                    gregorian: new DateObject({
                      date: endDate,
                      format: "HH:mm:ss   YYYY/MM/DD",
                    })
                      .convert(gregorian, gregorian_en)
                      .format(),
                  }
                : dateFormat;

              return {
                ...form,
                markAsAttended: form.markAsAttended || false,
                limits: {
                  ...form.limits,
                  startDate: formattedStartDate,
                  endDate: formattedEndDate,
                },
              };
            }
          );
          field["selectionList"] = transformedSelectionList;
          if (item.details.type === "RadioButton") {
            field["examQuestionHasRightAnswer"] =
              item?.details?.examQuestionHasRightAnswer || false;
            field["examQuestionRightAnswer"] =
              item?.details?.examQuestionRightAnswer || "";
          }
        } else if (item.details.type === "File") {
          field["fileType"] = item.details?.fileType;
        }

        if (item.details.visibilityCondition) {
          field["visibilityConditionSource"] =
            item.details.visibilityConditionSource;
          field["visibilityConditionValue"] =
            item.details.visibilityConditionValue;
        } else {
          field["visibilityConditionSource"] = "";
          field["visibilityConditionValue"] = "";
        }
        return field;
      });
      dispatch(setFormFields(fields));
    } else {
      dispatch(
        setFormSettings({
          formTitle: "",
          formDesc: "",
          formSubTitle: "",
          formIcon: "",
          formPoster: "",
          formType: "",
          confirmation: "",
          privacyMode: false,
          formLimit: false,
          limitCount: 0,
          hasDateLimit: false,
          startDate: dateFormat,
          endDate: dateFormat,
          accessList: false,
          accessListTopic: "",
          accessListType: "",
          blackAccessList: false,
          blackAccessListTopic: "",
          blackAccessListType: "",
          blackAccessListError: "",
          removable: false,
          maxQuestions: 0,
          durationEnabled: false,
          durationMinutes: 1,
        })
      );
      dispatch(setFormFields([]));
    }
  }, [form, dispatch]);

  return (
    <>
      <Paper elevation={0}>
        {isSetting ? <FormSettingFields /> : <FormFields />}
      </Paper>
      <Box display={"flex"} justifyContent={"start"} marginTop={"16px"}>
        <Button variant="contained" color="primary" onClick={submitForm}>
          ثبت فرم
        </Button>
      </Box>
    </>
  );
};

export default CurrFormContainer;
